import * as React from "react";
import { RadiosEditor } from "../../../../react-core/Html/RadiosEditor";
import { SubAccountType } from "../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { SubAccountTypeHelper } from "../../../Dashboard/Components/Clients/Common/Helpers/SubAccountTypeHelper";
import { IProcessComponentProps, ProcessComponent } from "../../Process/Process/ProcessComponent";

interface IReuseProps extends IProcessComponentProps {
    data: SubAccountType;
}

interface IReuseState {}

export class Reuse extends ProcessComponent<IReuseProps, IReuseState> {
    constructor(props: IReuseProps) {
        super(props);
        this.state = {};
    }

    render() {
        const { data, onChange } = this.props;
        if (!data) {return null;}
        return (
            <RadiosEditor
                cssWrapper="control-size-430 mb-30 rg-inline"
                selected={false}
                label={`Would you like to use the same investment as per ${
                    SubAccountTypeHelper.isOnPlatformPension(data) || SubAccountTypeHelper.isOffPlatformPension(data) ? "abrdn SIPP" : "ISA"
                }?`}
                options={[true, false]}
                onChange={(v) => {
                    onChange(v);
                }}
                getText={(o: any) => (o ? "Yes" : "No")}
            />
        );
    }
}
